module.exports = __webpack_public_path__ + "img/rifle.ak.ice.924566d0.png";